import React                 from 'react';
import { Flex, Box, Center } from '@chakra-ui/react';
import Img                   from 'gatsby-image';
import { graphql }           from 'gatsby';

import Heading       from '@interness/web-core/src/components/text/Heading/Heading';
import HeaderMedia   from '@interness/theme-default/src/components/HeaderMedia';
import Wrapper       from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import { findMedia } from '@interness/web-core/src/components/_helpers';
import Spacer        from '@interness/web-core/src/components/structure/Spacer/Spacer';

import Subnavigation from '../components/Subnavigation';

const ChemiepalettenPage = (props) => {
  return (
    <>
      <HeaderMedia id="produkte"/>
      <Subnavigation title="Produkte" menu={[
        {
          'displayName': 'Fertigung',
          'path': '/fertigung'
        },
        {
          'displayName': 'Europaletten',
          'path': '/europaletten'
        },
        {
          'displayName': 'Paletten 1/2/3 weg',
          'path': '/paletten-123-weg'
        },
        {
          'displayName': 'Sonderpaletten',
          'path': '/sonderpaletten'
        },
        {
          'displayName': 'Chemiepaletten',
          'path': '/chemiepaletten'
        },
        {
          'displayName': 'Euro-Gitterboxen',
          'path': '/euro-gitterboxen'
        },
        {
          'displayName': 'Vermietung / Reparaturen',
          'path': '/vermietung-reparaturen'
        }
      ]}/>
      <Spacer/>
      <Wrapper>
        <Heading>Chemiepaletten</Heading>
        <Spacer/>

        <Flex flexWrap="wrap">
          <Box width={['100%', '100%', '40%', '40%']}>
            <h3>Chemiepaletten</h3>
            <p>
              Individuelle Fertigung nach Kundenwunsch
            </p>
            <p>Chemiepaletten nach CP-Spezifikation</p>
            Abmessungen in mm
            <ul>
              <li>CP-1 1000 x 1200</li>
              <li>CP-2   800 x 1200</li>
              <li>CP-3 1140 x 1140</li>
              <li>CP-4 1100 x 1300</li>
              <li>CP-5   760 x 1140</li>
              <li>CP-6 1200 x 1000</li>
              <li>CP-7 1300 x 1100</li>
              <li>CP-8 1140 x 1140</li>
            </ul>
          </Box>
          <Box width={['100%', '100%', '60%', '60%']} px={6}>
            <Center>
              <Img fixed={findMedia(props.data.collection.images, 'pg-chemie-palette').childImageSharp.fixed}/>
            </Center>
          </Box>
        </Flex>
      </Wrapper>
      <Spacer/>
    </>
  )
};

export default ChemiepalettenPage;


export const query = graphql`
    query {
        collection: directusMediaCollection(name: {eq: "chemiepaletten"}) {
            name
            images: media {
                file {
                    localFile {
                        name
                        childImageSharp {
                            fixed {
                                ...GatsbyImageSharpFixed
                            }
                        }
                    }
                }
            }
        }
    }
`;